//Components
import ScrollSnap from '../components/ScrollSnap'
//Images
import iata_mb from '../assets/images/iata-mb.png'
import iata_dt from '../assets/images/iata-dt.png'
import safe_travels_mb from '../assets/images/safe-travels-mb.png'
import safe_travels_dt from '../assets/images/safe-travels-dt.png'
import destino_arg_mb from '../assets/images/destino-arg-mb.png'
import destino_arg_dt from '../assets/images/destino-arg-dt.png'
import pais_arg_mb from '../assets/images/pais-arg-mb.png'
import pais_arg_dt from '../assets/images/pais-arg-dt.png'
import aviabue_mb from '../assets/images/aviabue-mb.png'
import aviabue_dt from '../assets/images/aviabue-dt.png'

const OperatorsGallery = () => {
    return (
        <div className="operators-gallery">
            <ScrollSnap type="mandatory" columnGap="24" columnGapDt="40" columnGapDtLarge="40">
                <div className="operator-logo">
                    <picture>
                        <source media="(min-width: 768px )" srcSet={`${iata_dt}`} />
                        <img src={iata_mb} alt="Iata" />
                    </picture>
                </div>
                <div className="operator-logo">
                    <picture>
                        <source media="(min-width: 768px )" srcSet={`${safe_travels_dt}`} />
                        <img src={safe_travels_mb} alt="Safe Travels" />
                    </picture>
                </div>
                <div className="operator-logo">
                    <picture>
                        <source media="(min-width: 768px )" srcSet={`${destino_arg_dt}`} />
                        <img src={destino_arg_mb} alt="Destino Argentina" />
                    </picture>
                </div>
                <div className="operator-logo">
                    <picture>
                        <source media="(min-width: 768px )" srcSet={`${pais_arg_dt}`} />
                        <img src={pais_arg_mb} alt="Pais Argentina" />
                    </picture>
                </div>
                <div className="operator-logo">
                    <picture>
                        <source media="(min-width: 768px )" srcSet={`${aviabue_dt}`} />
                        <img src={aviabue_mb} alt="Aviabue" />
                    </picture>
                </div>
            </ScrollSnap>
        </div>
    )
}

export default OperatorsGallery
